<template>

    <div class="mother" v-show="langLoaded">

        <div id="app" :class="{ 'bloc-scroll': maintenance }">

            <div class="app__container">

                <navigation></navigation>

                <router-view class="app" :key="$route.path"/>

            </div>


            <maintenance :maintenance="maintenance"></maintenance>

            <modal-cookies-policy ref="mcp"></modal-cookies-policy>

            <cookie-law @manage="openCookieLaw"></cookie-law>

        </div>

        <metas></metas>

        <structured-data></structured-data>

        <agreements-update></agreements-update>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Firebase from './modules/firebase'
import I18n from './modules/i18n'
import Tag from './modules/tag'

import CookieLaw from './components/CookieLaw'
import Maintenance from './components/Maintenance'
import Metas from './components/Metas'
import ModalCookiesPolicy from './components/modal/ModalCookiesPolicy'
import Navigation from './components/Navigation'
import StructuredData from './components/StructuredData.vue'
import AgreementsUpdate from './components/AgreementsUpdate'

import Storage from './helpers/storage'

export default {

    components: {
        AgreementsUpdate,
        CookieLaw,
        Maintenance,
        Metas,
        ModalCookiesPolicy,
        Navigation,
        StructuredData
    },

    computed: {

        ...Vuex.mapGetters([
            'maintenance',
            'lang',
            'langLoaded',
            'seasonalEvent'
        ])

    },

    created() {

        I18n.created(this)

        const regexNative = new RegExp('^/fox/native/')
        if (!regexNative.test(this.$route.path)) {
            Tag.initTracking(this)
        }

    },

    async mounted() {

        window.scrollTo(0, 1)

        const emailToDeleteRedirect = Storage.getItem('emailToDeleteRedirect')
        if(emailToDeleteRedirect) {
            Storage.removeItem('emailToDeleteRedirect')
            this.updateEmailToDeleteRedirect(emailToDeleteRedirect)
        }

        // disable seasonal events while waiting for the next one for speedIndex
        // await this.updateSeasonal()

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize)
        })
    },

    methods: {

        ...Vuex.mapActions([
            'updateEmailToDeleteRedirect',
            'updateInnerHeight',
            'updateInnerWidth',
            'updateSeasonalEvent'
        ]),

        openCookieLaw() {

            this.$refs.mcp.open()
        },

        async updateSeasonal() {
            const firebaseSeasonalEvent = await Firebase.getValue(Firebase.KEYS.EVENT_UI, Firebase.TYPES.STRING)
            if(firebaseSeasonalEvent) {
                this.updateSeasonalEvent(firebaseSeasonalEvent)
                this.updateFavIcon()
            }
        },

        updateFavIcon() {
            if(this.seasonalEvent) {
                // no fav icon for the next event
                // document.querySelector('link[rel="shortcut icon"]').href = ''
            }
        },

        onResize() {
            this.updateInnerWidth(window.innerWidth)
            this.updateInnerHeight(window.innerHeight)
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
}

</script>

<style lang="scss" src="./style/main.scss"></style>

<style lang="scss" scoped>

.mother {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.app {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    overflow-x: hidden;
    overflow-y: scroll;

    &__container {
        display: flex;
        flex-direction: column-reverse;
        flex-grow: 1;
        overflow: hidden;

        @media screen and (min-width: $above-tablet-length) {
            flex-direction: row;

            &:lang(ar-sa) {
                direction: rtl;
            }
        }
    }
}

.bloc-scroll {
    overflow: hidden;
}

</style>

